__turbopack_context__.v({
  "answerbox-enter": "lI9X5W_answerbox-enter",
  "answerbox-exit": "lI9X5W_answerbox-exit",
  "entry-enter": "lI9X5W_entry-enter",
  "option-enter": "lI9X5W_option-enter",
  "option-exit": "lI9X5W_option-exit",
  "progress-buildup": "lI9X5W_progress-buildup",
  "quiz": "lI9X5W_quiz",
  "quiz--fluid": "lI9X5W_quiz--fluid",
  "quiz--no-scroll": "lI9X5W_quiz--no-scroll",
  "quiz__answer-box": "lI9X5W_quiz__answer-box",
  "quiz__answer-box--correct": "lI9X5W_quiz__answer-box--correct",
  "quiz__answer-box--wrong": "lI9X5W_quiz__answer-box--wrong",
  "quiz__answer-box-wrapper": "lI9X5W_quiz__answer-box-wrapper",
  "quiz__answer-icon": "lI9X5W_quiz__answer-icon",
  "quiz__button": "lI9X5W_quiz__button",
  "quiz__control": "lI9X5W_quiz__control",
  "quiz__control--back": "lI9X5W_quiz__control--back",
  "quiz__control--right": "lI9X5W_quiz__control--right",
  "quiz__controls": "lI9X5W_quiz__controls",
  "quiz__entry": "lI9X5W_quiz__entry",
  "quiz__illustration": "lI9X5W_quiz__illustration",
  "quiz__illustration--entry": "lI9X5W_quiz__illustration--entry",
  "quiz__index": "lI9X5W_quiz__index",
  "quiz__intro": "lI9X5W_quiz__intro",
  "quiz__media": "lI9X5W_quiz__media",
  "quiz__nav": "lI9X5W_quiz__nav",
  "quiz__option": "lI9X5W_quiz__option",
  "quiz__option--correct": "lI9X5W_quiz__option--correct",
  "quiz__option--promoted": "lI9X5W_quiz__option--promoted",
  "quiz__option--restart": "lI9X5W_quiz__option--restart",
  "quiz__option--results": "lI9X5W_quiz__option--results",
  "quiz__option--selected": "lI9X5W_quiz__option--selected",
  "quiz__option--wrong": "lI9X5W_quiz__option--wrong",
  "quiz__options": "lI9X5W_quiz__options",
  "quiz__options--odd": "lI9X5W_quiz__options--odd",
  "quiz__preamble": "lI9X5W_quiz__preamble",
  "quiz__question": "lI9X5W_quiz__question",
  "quiz__result": "lI9X5W_quiz__result",
  "quiz__score": "lI9X5W_quiz__score",
  "quiz__score-card": "lI9X5W_quiz__score-card",
  "quiz__score-card-content": "lI9X5W_quiz__score-card-content",
  "quiz__selected-icon": "lI9X5W_quiz__selected-icon",
  "quiz__step": "lI9X5W_quiz__step",
  "quiz__sub-title": "lI9X5W_quiz__sub-title",
  "quiz__summary-answer": "lI9X5W_quiz__summary-answer",
  "quiz__summary-answer--correct": "lI9X5W_quiz__summary-answer--correct",
  "quiz__summary-answer--wrong": "lI9X5W_quiz__summary-answer--wrong",
  "quiz__summary-item": "lI9X5W_quiz__summary-item",
  "quiz__summary-list": "lI9X5W_quiz__summary-list",
  "quiz__tag": "lI9X5W_quiz__tag",
  "quiz__title": "lI9X5W_quiz__title",
  "quiz__title--intro": "lI9X5W_quiz__title--intro",
  "quiz__wrapper": "lI9X5W_quiz__wrapper",
  "title-enter": "lI9X5W_title-enter",
  "title-exit": "lI9X5W_title-exit",
});
